<template>
  <div id="qualityReport" class="p-10px h-full" v-loading="loading">
    <el-row>
      <el-col :span="12" class="pr-5px">
        <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
          <h3 class="fz-18 b mb-10px">数据质量概况</h3>
          <el-row v-loading="standReportLoading">
            <el-col :span="8" v-for="(item, index) in qualityList" :key="index">
              <el-col :span="10" class="tr">
                <div v-html="getIcon(item)"></div>
              </el-col>
              <el-col :span="13" :offset="1">
                <div class="fz-18 b">{{ item.name }}</div>
                <div>{{ item.number }}个</div>
              </el-col>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12" class="pl-5px">
        <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
          <h3 class="fz-18 b mb-10px">数据质量任务</h3>
          <el-row v-loading="taskReportLoading">
            <el-col :span="8" v-for="(item, index) in taskList" :key="index">
              <el-col :span="10" class="tr">
                <div v-html="getIcon(item)"></div>
              </el-col>
              <el-col :span="13" :offset="1">
                <div class="fz-18 b">{{ item.name }}</div>
                <div>{{ item.number }}个</div>
              </el-col>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mt-10px mb-5px" style="height: calc(100% - 117px)">
      <el-col :span="16" class="h-full pr-5px">
        <el-card
          class="h-full"
          :body-style="{ padding: '10px', height: '100%' }"
          v-loading="historyReportLoading"
        >
          <div class="h-50 flex">
            <v-chart
              class="h-full w-50 dib float-left"
              style="height: 100%"
              :options="pieOption"
            ></v-chart>
            <v-chart
              class="h-full w-50 dib float-right"
              style="height: 100%"
              :options="barOption"
            ></v-chart>
          </div>
          <div class="h-50">
            <v-chart class="h-full w-full" :options="lineOption"></v-chart>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" class="h-full pl-5px">
        <el-card class="h-full" :body-style="{ padding: '0px', height: '100%' }">
          <h3 class="pl-10px pr-10px fz-16 b" style="height: 44px; line-height: 44px;">
            数据质量问题 TOP 10
          </h3>
          <el-row style="height: calc(100% - 44px)">
            <el-table :data="tableData" class="w-full" height="100%" v-loading="topReportLoading">
              <el-table-column
                show-overflow-tooltip
                prop="standardName"
                label="所属标准库"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="classCode"
                label="类代码"
                width="120"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="errorCount"
                label="错误数"
                width="90"
              ></el-table-column>
            </el-table>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import QualityTaskService from '@/services/QualityTaskService'

export default {
  name: 'qualityReport',
  mixins: [],
  components: {},
  data() {
    return {
      loading: false,
      standardCount: 0,
      tableCount: 0,
      ruleCount: 0,
      qualityList: [
        {
          id: 1,
          name: '标准库',
          number: 2,
          icon: 'icon1',
        },
        {
          id: 2,
          name: '类库',
          number: 2,
          icon: 'icon2',
        },
        {
          id: 3,
          name: '规则数',
          number: 2,
          icon: 'icon3',
        },
      ],
      taskList: [
        {
          id: 1,
          name: '成功数',
          number: 2,
          icon: 'icon4',
        },
        {
          id: 2,
          name: '待执行',
          number: 2,
          icon: 'icon5',
        },
        {
          id: 3,
          name: '失败',
          number: 2,
          icon: 'icon6',
        },
      ],
      // 饼图option
      pieOption: {
        color: ['#2e75f6', '#45a2ed', '#8adefb', '#baedff', '#d1f3ff'],
        title: {
          text: '规则问题',
          left: 'left',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: 'center',
          left: '0',
          textStyle: {
            color: '#fff',
          },
          icon: 'circle',
          orient: 'vertical',
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      },
      // 柱状图Option
      barOption: {
        title: {
          text: '问题发现次数历史趋势情况',
          left: 'left',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
            axisLine: {
              lineStyle: {
                color: '#fff',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
            axisLine: {
              lineStyle: {
                color: '#fff',
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '',
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#8adefb',
                barBorderRadius: 20,
              },
            },
            barWidth: 20,
            data: [],
          },
          {
            name: '',
            type: 'bar',
            barGap: '-100%',
            itemStyle: {
              normal: {
                color: '#2e75f6',
                barBorderRadius: 20,
              },
            },
            barWidth: 20,
            data: [],
          },
        ],
      },
      // 折线图option
      lineOption: {
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            data: [],
            type: 'line',
            itemStyle: {
              normal: {
                color: '#94303a',
              },
            },
          },
        ],
      },
      tableData: [],
      topReportLoading: false, // 问题排行报告
      historyReportLoading: false, // 问题发现次数历史趋势报告
      ruleReportLoading: false, // 规则问题报告
      taskReportLoading: false, // 数据质量任务报告
      standReportLoading: false, // 标准库报告
    }
  },
  computed: {
    icon1() {
      return '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon-path-icon fill" viewBox="0 0 448 512" width="60" height="60"><path fill="#ffcc00" d="M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"></path></svg>'
    },
    icon2() {
      return '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon-path-icon fill" viewBox="0 0 512 512" width="60" height="60"><path fill="#009eca" d="M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"></path></svg>'
    },
    icon3() {
      return '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon-path-icon fill" viewBox="0 0 384 512" width="60" height="60"><path fill="#31b576" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"></path></svg>'
    },
    icon4() {
      return '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon-path-icon fill" viewBox="0 0 24 24" width="60" height="60"><path fill="#31b576" d="M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"></path></svg>'
    },
    icon5() {
      return '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon-path-icon fill" viewBox="0 0 24 24" width="60" height="60"><path fill="#ea9317" d="M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"></path></svg>'
    },
    icon6() {
      return '<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon-path-icon fill" viewBox="0 0 512 512" width="60" height="60"><path fill="#fe5868" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg>'
    },
  },
  watch: {},
  methods: {
    getIcon(item) {
      return this[item.icon]
    },
    // 页面数据
    async getData() {
      this.loading = true
      const res = await QualityTaskService.getReportData()
      if (res && res.code === 0 && res.data) {
        // 数据质量数据
        if (res.data.dataQuality) {
          this.qualityList[0].number = res.data.dataQuality.standardCount
          this.qualityList[1].number = res.data.dataQuality.tableCount
          this.qualityList[2].number = res.data.dataQuality.ruleCount
        }

        // 数据质量任务
        if (res.data.dataQualityTask) {
          this.taskList[0].number = res.data.dataQualityTask.successCount
          this.taskList[1].number = res.data.dataQualityTask.waitRunCount
          this.taskList[2].number = res.data.dataQualityTask.errorRunCount
        }
        if (res.data.ruleTypeList) {
          // 饼图数据
          const firstRow = _.head(res.data.ruleTypeList) || {}
          this.pieOption.series[0].data = _.map(res.data.ruleTypeList, (i) => {
            return { value: i.problemCount, name: i.ruleName }
          })
        }
        if (res.data.problemList) {
          // 柱状图数据
          this.barOption.xAxis[0].data = _.map(res.data.problemList, (i) => {
            return `${i.year}-${i.month}`
          })
          this.barOption.series[0].name = '检测总数'
          this.barOption.series[1].name = '问题数量'
          this.barOption.series[0].data = _.map(res.data.problemList, (i) => {
            return i.checkCount
          })
          this.barOption.series[1].data = _.map(res.data.problemList, (i) => {
            return i.errorCount
          })
          // 折线图数据
          this.lineOption.xAxis.data = _.map(res.data.problemList, (i) => {
            return `${i.year}-${i.month}`
          })
          this.lineOption.series[0].data = _.map(res.data.problemList, (i) => {
            return i.errorCount
          })
          // 10个问题最多数据
          this.tableData = res.data.problemMaxList
        }
      }
      this.loading = false
    },
    // 问题排行报告
    async getDataQualityTopReport() {
      this.topReportLoading = true
      const res = await QualityTaskService.getDataQualityTopReport()
      this.topReportLoading = false
      if (res && res.data && res.code === 0) {
        // 10个问题最多数据
        this.tableData = res.data.problemMaxList
      }
    },
    // 问题发现次数历史趋势报告
    async getDataQualityHistoryReport() {
      this.historyReportLoading = true
      const res = await QualityTaskService.getDataQualityHistoryReport()
      this.historyReportLoading = false
      if (res && res.data && res.code === 0) {
        if (res.data.problemList) {
          // 柱状图数据
          this.barOption.xAxis[0].data = _.map(res.data.problemList, (i) => {
            return `${i.year}-${i.month}`
          })
          this.barOption.series[0].name = '检测总数'
          this.barOption.series[1].name = '问题数量'
          this.barOption.series[0].data = _.map(res.data.problemList, (i) => {
            return i.checkCount
          })
          this.barOption.series[1].data = _.map(res.data.problemList, (i) => {
            return i.errorCount
          })
          // 折线图数据
          this.lineOption.xAxis.data = _.map(res.data.problemList, (i) => {
            return `${i.year}-${i.month}`
          })
          this.lineOption.series[0].data = _.map(res.data.problemList, (i) => {
            return i.errorCount
          })
        }
      }
    },
    // 规则问题报告
    async getDataRuleReport() {
      this.ruleReportLoading = true
      const res = await QualityTaskService.getDataRuleReport()
      this.ruleReportLoading = false
      if (res && res.data && res.code === 0) {
        if (res.data.ruleTypeList) {
          // 饼图数据
          const firstRow = _.head(res.data.ruleTypeList) || {}
          this.pieOption.series[0].data = _.map(res.data.ruleTypeList, (i) => {
            return { value: i.problemCount, name: i.ruleName }
          })
        }
      }
    },
    // 数据质量任务报告
    async getDataQualityTaskReport() {
      this.taskReportLoading = true
      const res = await QualityTaskService.getDataQualityTaskReport()
      this.taskReportLoading = false
      if (res && res.data && res.code === 0) {
        if (res.data.dataQualityTask) {
          this.taskList[0].number = res.data.dataQualityTask.successCount
          this.taskList[1].number = res.data.dataQualityTask.waitRunCount
          this.taskList[2].number = res.data.dataQualityTask.errorRunCount
        }
      }
    },
    // 标准库报告
    async getDataStandReport() {
      this.standReportLoading = true
      const res = await QualityTaskService.getDataStandReport()
      this.standReportLoading = false
      if (res && res.data && res.code === 0) {
        if (res.data.dataQuality) {
          this.qualityList[0].number = res.data.dataQuality.standardCount
          this.qualityList[1].number = res.data.dataQuality.tableCount
          this.qualityList[2].number = res.data.dataQuality.ruleCount
        }
      }
    },
  },
  created() {
    this.getDataQualityTopReport()
    this.getDataQualityHistoryReport()
    this.getDataRuleReport()
    this.getDataQualityTaskReport()
    this.getDataStandReport()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
}
</script>
<style lang="scss" scoped>

#qualityReport {
  display: flex;
  flex-direction: column;
  background: #081326;
  /deep/.el-card__body {
    background: #272b5a !important;
    color: #fff;
    border: none;
    border-radius: 0;
  }
  /deep/ .el-table::before {
    height: 0;
  }
  /deep/ .el-table__row {
    color: #64e5ce;
  }
  /deep/ .el-table th {
    background: none !important;
    color: #fff;
  }
  /deep/ .el-table--enable-row-hover,
  /deep/ .el-table__body tr:hover > td {
    background: none !important;
  }
  /deep/ .el-table th.is-leaf,
  /deep/ .el-table td {
    border: none !important;
  }
  .flex-1 {
    flex: 1;
  }
  .icon-bg {
    display: inline-block;
    width: 50px;
    height: 50px;
    line-height: 50px;
    background: rgb(97, 105, 113);
    color: #fff;
    border-radius: 50%;
    font-size: 26px;
    text-align: center;
  }
  .h-50 {
    height: 50%;
  }
  .w-50 {
    width: 50%;
  }
  /deep/.el-table__body-wrapper::-webkit-scrollbar {
    background-color: transparent;
    width: 8px;
    height: 8px;
  }
  /deep/.el-table__body-wrapper::-webkit-scrollbar:hover {
    background-color: transparent;
    box-shadow: none;
  }

  /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
    //设置滑块
    background-color: rgba(165, 169, 173, 0.3);
    border-radius: 8px;
    box-shadow: none;
  }
  /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: rgba(165, 169, 173, 0.6);
    box-shadow: none;
  }
  /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:active {
    background-color: rgba(165, 169, 173, 0.8);
  }
  /deep/.el-table th,
  .el-table tr {
    background: none !important;
  }
  /deep/.el-table tr {
    background: none !important;
  }
}

</style>
